// Determine if version is greater than all the versions possible in the range.
const outside = require('./outside')
const gtr = (version, range, options) => outside(version, range, '>', options)
module.exports = gtr



//////////////////
// WEBPACK FOOTER
// ./~/semver/ranges/gtr.js
// module id = 2196
// module chunks = 0